import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  root: {
    minWidth: '330px'
  },
  list: {
    padding: 0
  },
  listItemIcon: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))
